class NavbarScroll {
    constructor() {
        this.navbar = null;
        this.brandImg = null;
        this.scrollThreshold = 50;
        this.maxScroll = 300;
        this.baseLogoHeight = 8.69; // 6rem
        this.minLogoHeight = 5.56; // 4rem
        this.isScrolled = false;

        this.init();
    }

    init() {
        document.addEventListener('DOMContentLoaded', () => {
            this.setupElements();
            this.bindEvents();
        });
    }

    setupElements() {
        this.navbar = document.querySelector('.navbar');
        this.brandImg = document.querySelector('.navbar-brand img');

        if (!this.navbar) {
            console.warn('Navbar not found');
            return;
        }

        // Set initial logo height
        if (this.brandImg) {
            this.brandImg.style.height = `${this.baseLogoHeight}rem`;
            this.brandImg.style.transition = 'height 0.3s ease';
        }

        // Add transition for navbar background
        this.navbar.style.transition = 'background-color 0.3s ease, box-shadow 0.3s ease';
    }

    bindEvents() {
        let ticking = false;

        const handleScroll = () => {
            if (!ticking) {
                requestAnimationFrame(() => {
                    this.updateNavbar();
                    ticking = false;
                });
                ticking = true;
            }
        };

        window.addEventListener('scroll', handleScroll, { passive: true });
    }

    updateNavbar() {
        const scrollY = window.scrollY;
        const scrollProgress = Math.min(scrollY / this.maxScroll, 1);

        // Handle navbar background
        if (scrollY > this.scrollThreshold && !this.isScrolled) {
            this.isScrolled = true;
            this.navbar.classList.add('navbar-scrolled');
        } else if (scrollY <= this.scrollThreshold && this.isScrolled) {
            this.isScrolled = false;
            this.navbar.classList.remove('navbar-scrolled');
        }

        // Handle logo scaling
        if (this.brandImg) {
            const heightDiff = this.baseLogoHeight - this.minLogoHeight;
            const currentHeight = this.baseLogoHeight - (heightDiff * scrollProgress);
            this.brandImg.style.height = `${Math.max(currentHeight, this.minLogoHeight)}rem`;
        }
    }
}

export default NavbarScroll;
